import React, { lazy } from 'react';
import { Route, Switch, useParams } from 'react-router-dom';

import { ErrorBoundary } from '@monorepo/common';

import { book } from './books';

const NoshBrandHub = lazy(() => import('../pages/nosh-brands/Hub'));
const NoshEditBrand = lazy(() => import('../pages/nosh-brands/EditBrand'));
const NoshProducts = lazy(() => import('../pages/nosh-brands/Products'));
const NoshCreateProduct = lazy(() => import('../pages/nosh-brands/CreateProduct'));
const NoshProductDetails = lazy(() => import('../pages/nosh-brands/ProductDetails'));
const NoshCreateSubBrand = lazy(() => import('../pages/nosh-brands/CreateSubBrand'));
const NoshWhereToBuy = lazy(() => import('../pages/nosh-brands/WhereToBuy'));

// Keyed by product as well: Back/Forward (or the browser's history menu) can go straight from one
// product to another, which must not carry product A's edits or picked image over to product B.
const NoshProductDetailsRoute = () => {
  const { productGuid } = useParams<{ productGuid: string }>();
  return <NoshProductDetails key={productGuid} />;
};

// Every NOSH brand page sits under one Switch keyed by the brand, so switching brands (sidebar, Back)
// remounts the page and anything open in it: no form or dialog can carry one brand's values into another.
const NoshBrandRoutes = () => {
  const { brandGuid } = useParams<{ brandGuid: string }>();

  return (
    <Switch key={brandGuid}>
      <Route exact path={book.noshBrands.hub()}>
        <ErrorBoundary>
          <NoshBrandHub />
        </ErrorBoundary>
      </Route>
      <Route exact path={book.noshBrands.edit()}>
        <ErrorBoundary>
          <NoshEditBrand />
        </ErrorBoundary>
      </Route>
      <Route exact path={book.noshBrands.products()}>
        <ErrorBoundary>
          <NoshProducts />
        </ErrorBoundary>
      </Route>
      {/* Before the :productGuid route, which would also match "new". */}
      <Route exact path={book.noshBrands.createProduct()}>
        <ErrorBoundary>
          <NoshCreateProduct />
        </ErrorBoundary>
      </Route>
      <Route exact path={book.noshBrands.product()}>
        <ErrorBoundary>
          <NoshProductDetailsRoute />
        </ErrorBoundary>
      </Route>
      <Route exact path={book.noshBrands.createSubBrand()}>
        <ErrorBoundary>
          <NoshCreateSubBrand />
        </ErrorBoundary>
      </Route>
      <Route exact path={book.noshBrands.whereToBuy()}>
        <ErrorBoundary>
          <NoshWhereToBuy />
        </ErrorBoundary>
      </Route>
    </Switch>
  );
};

export default NoshBrandRoutes;
